import CSSPoppy from './CSSPoppy.js';

export function random( min, max ) {
    return min + Math.random() * ( max - min );
}

export function randomChange(x) {
    return {
        by: (y)=>{
            return random(x-y, x+y);
        },
        byRange: (y, z)=>{
            return random(x+y, x+z);
        },
        or: (y)=>{
            if (Math.random() > 0.5) {
                return y;
            } else { return x; }
        },
    };
}

export function unwrapLetters(p) {
    const name = p.querySelector('.name');
    name.innerHTML = name.innerText;
    p.classList.remove('letters-wrapped');
}

export function wrapLetters(name) {
    let letters;
    try {
        letters = Array.from(name);
    } catch(e) {
        return;
    }

    const middles = [];
    middles.length = Math.floor(letters.length * 0.2);
    middles.fill('middle');

    const sides = [];
    sides.length = Math.floor(letters.length * 0.15);
    sides.fill('sides');

    const classes = [];
    classes.length = Math.round(letters.length * 0.25);
    classes.fill('edge');

    classes.push(...sides, ...middles, ...sides);

    return letters.map((l)=>{
        let className = classes.shift() || 'edge';
        if ( l === 'Y' ) { className += ' letter-Y'; }
        return `<span class="${className}">${l}</span>`;
    }).join('');
}


export function populateNames() {
    const wrappedClass = 'text-wrapped';
    const observerCallback = (entries)=>{
        entries.forEach((entry)=>{
            if ( entry.isIntersecting ) {
                const nameEl = entry.target.querySelector('.name');
                nameEl.innerHTML = wrapLetters(nameEl.innerText);
                entry.target.classList.add(wrappedClass);
            } else {
                if (!entry.target.classList.contains(wrappedClass)) return;
                const nameEl = entry.target.querySelector('.name');
                nameEl.innerHTML = nameEl.innerText;
                entry.target.classList.remove(wrappedClass);
            }
        });
    }

    const observer = new IntersectionObserver((entries)=>{
        window.requestIdleCallback(()=>{observerCallback(entries)}, {
            timeout: 1000,
        });
    });

    return new Promise(async (res)=>{
        const decoder = new TextDecoder();
        const response = await fetch('./names.csv');
        const text = await response.text();
        const names = text.split(/[\n\r]+/g);
        const list = document.querySelector('.heroes');
        const fakeParent = document.createElement('li');
        names.forEach((name)=>{
            if (name === '') { return; }

            /* parse number out */
            let number;
            const numberMatch = name.match(/\d+(?:\/\d+)?/);
            if (numberMatch) {
                number = numberMatch[0];
            }
            name = name.replace(number, '');
            // name = wrapLetters(name);


            let elementString = `<li class="hero"><span class="name">${name}</span> ${number ? `<span class="number">${number}</span>` : ''}</li>`;
            fakeParent.innerHTML = elementString;
            const li = fakeParent.firstChild;
            list.appendChild(li);
        });

        const heroEls = document.querySelectorAll('.hero');
        heroEls.forEach((li, i)=>{
            observer.observe(li);
            if (i > heroEls.length - 20) {
                const nameEl = li.querySelector('.name');
                nameEl.innerHTML = wrapLetters(nameEl.innerText);
                li.classList.add(wrappedClass);
            }
        });

        setTimeout(res, 5000);
    });
}




export function addConfigRules(C = window.C) {
    if (!C) return;

    const styleSheet = Array.from(document.styleSheets).find((sheet)=>{
        return sheet.href.includes('roll-of-honor.css')
    });

    if (styleSheet.insertRule) {
        /* Amimation config for span */
        styleSheet.insertRule(`
            .hero.current span {
                ${ (C.shineEffect) ? '' : 'animation: none;'}
                animation-duration: ${C.shineTime / 1000}s;
                animation-delay: ${C.shineDelay / 1000}s;
            }
        `, styleSheet.cssRules.length);

        /* Transition for opacity */
        styleSheet.insertRule(`
            .hero.current {
                transition-duration: ${C.opacityTime / 1000}s;
                transition-delay: ${C.opacityDelay / 1000}s;
            }
        `, styleSheet.cssRules.length);

        styleSheet.insertRule(`
            .cover {
                width: ${C.coverWidth}%;
                border: 1px solid ${C.debug ? 'green' : 'transparent'};
            }
        `, styleSheet.cssRules.length);
    } else {
        /* Amimation config for span */
        styleSheet.addRule('.hero.current span', `
            ${ (C.shineEffect) ? '' : 'animation: none;'}
            animation-duration: ${C.shineTime / 1000}s;
            animation-delay: ${C.shineDelay / 1000}s;
        `,  styleSheet.cssRules.length);

        /* Transition for opacity */
        styleSheet.addRule('.hero.current', `
            transition-duration: ${C.opacityTime / 1000}s;
            transition-delay: ${C.opacityDelay / 1000}s;
        `,  styleSheet.cssRules.length);

        styleSheet.addRule('.cover', `
            width: ${C.coverWidth}%;
            border: 1px solid ${C.debug ? 'green' : 'transparent'};
        `,  styleSheet.cssRules.length);
    }
}



export function addCSSPoppy() {
    return new CSSPoppy();
}



// WEBPACK FOOTER //
// ./roll_of_honor/javascript/helpers.js